import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Trophy } from 'lucide-react';
import { getMatchResult } from './utils';

export const RecentFormWidget = ({ stats, user }) => (
  <Card className="card-hover h-full" data-testid="recent-form">
    <CardHeader className="flex flex-row items-center justify-between pb-4">
      <CardTitle className="text-xl font-semibold font-title">Recent Form</CardTitle>
      <Link to="/matches">
        <Button variant="ghost" size="sm" style={{ color: user?.menu_color || '#059669' }} className="hover:opacity-80">
          View All
        </Button>
      </Link>
    </CardHeader>
    <CardContent>
      {stats?.recent_results?.length > 0 ? (
        <div className="flex justify-center gap-3">
          {stats.recent_results.slice(0, 5).map((match) => {
            const result = getMatchResult(match);
            return (
              <div key={match.id} className="flex flex-col items-center">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center font-bold ${result.color}`}>
                  {result.label}
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  {match.is_cup && match.our_score_et != null && match.opponent_score_et != null
                    ? `${match.our_score_et}-${match.opponent_score_et}`
                    : `${match.our_score}-${match.opponent_score}`}
                </p>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-400">
          <Trophy className="w-10 h-10 mx-auto mb-2 opacity-50" strokeWidth={1.5} />
          <p>No results yet</p>
        </div>
      )}
    </CardContent>
  </Card>
);

export default RecentFormWidget;
